import { useState, useCallback, useEffect } from 'react';
import { CONFIG } from '../../../../config';
import { PENDING_SRC } from '../../../../constants/pendingSrc';

export const useDesktopProductMediaGalleryVideoThumb = (videoId: string) => {
  const [thumbnail, setThumbnail] = useState<string>(PENDING_SRC);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<undefined | string>(undefined);
  const [fetched, setFetched] = useState(false);

  const fetchVideoThumbnail = useCallback(() => {
    setLoading(true);

    fetch(`${CONFIG.BRIGHTCOVE_API_BASE_URL}/${CONFIG.BRIGHTCOVE_ACCOUNT_ID}/videos/${videoId}`, {
      method: 'GET',
      headers: {
        Accept: `application/json;pk=${CONFIG.BRIGHTCOVE_POLICY_KEY}`
      },
      redirect: 'follow'
    })
      .then(response => {
        return response.json();
      })
      .then(result => {
        if (result.thumbnail) {
          setThumbnail(result.thumbnail);
        }

        setFetched(true);

        setLoading(false);
      })
      .catch(error => {
        setError(error);
      });
  }, [videoId]);

  useEffect(() => {
    if (fetched) return;

    fetchVideoThumbnail();
  }, [fetchVideoThumbnail, fetched]);

  return { thumbnail, loading, error };
};
